module.exports = __webpack_public_path__ + "media/images/icons/credit_card/visa-883741353b20e0f73d88ac21f4a76f59.svg";